module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-badge"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Badge")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('zan-badge-group', {
    attrs: {
      "active-key": "2"
    }
  }, [_c('zan-badge', {
    attrs: {
      "mark": "0",
      "title": "热销榜",
      "info": "8",
      "url": "http://baidu.com"
    }
  }), _vm._v(" "), _c('zan-badge', {
    attrs: {
      "mark": "1",
      "title": "花式寿司",
      "info": "99"
    }
  }), _vm._v(" "), _c('zan-badge', {
    attrs: {
      "mark": "2",
      "title": "火炽寿司"
    }
  }), _vm._v(" "), _c('zan-badge', {
    attrs: {
      "mark": "3",
      "title": "手握寿司",
      "info": "199"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a888038!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/badge.vue
// module id = 287
// module chunks = 0